import { render } from "./Celda-Component.vue?vue&type=template&id=3ba4c215&scoped=true"
import script from "./Celda-Component.vue?vue&type=script&lang=js"
export * from "./Celda-Component.vue?vue&type=script&lang=js"

import "./Celda-Component.vue?vue&type=style&index=0&id=3ba4c215&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba4c215"]])

export default __exports__